<script>
  import { noop } from "svelte/internal";
  import ChevronBackIcon from "../ChevronBackIcon.svelte";
  import CoinsAmount from "./CoinsAmount.svelte";

  export let bundle; // Bundle
  export let onBack = noop; // () => void
</script>

<style lang="stylus">
  h1
    margin-top 0
    margin-bottom 36px
    font-size 20px
    white-space nowrap

    span
      display inline-block

  .coins
    vertical-align middle

    > :global(*)
      vertical-align middle

  .back
    cursor pointer
    margin-right 6px
</style>

<h1>
  <span class="back" on:click={onBack}>
    <ChevronBackIcon />
  </span>
  <span class="coins">
    <CoinsAmount {bundle} showSupersededCoinsAmount={false} />
  </span>
</h1>
